// src/hooks/useBuyerPersonaQuestions.js
import { useState, useEffect } from 'react';
import buyerPersonaService from '../helpers/buyerPersonaService';

export const useBuyerPersonaQuestions = () => {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Cargar preguntas del cuestionario
    const loadQuestions = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await buyerPersonaService.getQuestions();
            if (response.success && response.questions && response.questions.length > 0) {
                setQuestions(response.questions);
                console.log('Preguntas cargadas:', response.questions.length);
            } else {
                throw new Error('No se pudieron cargar las preguntas');
            }
        } catch (err) {
            console.error('Error al cargar las preguntas del buyer persona:', err.message);
            // Si el backend no está listo, usar preguntas de ejemplo
            if (err.message.includes('No se pudieron cargar las preguntas') ||
                err.message.includes('Internal server error') ||
                err.message.includes('Network Error') ||
                err.message.includes('404')) {
                setError('El módulo de Buyer Persona no está disponible temporalmente');
            } else {
                setError('Error al cargar las preguntas del cuestionario');
            }
        } finally {
            setLoading(false);
        }
    };

    // Cargar preguntas al inicializar
    useEffect(() => {
        console.log('useBuyerPersonaQuestions - Loading questions...');
        loadQuestions();
    }, []);

    // Agrupar preguntas por módulo
    const getQuestionsByModule = (module) => {
        return questions.filter(question => question.module === module);
    };

    // Obtener todos los módulos disponibles
    const getAvailableModules = () => {
        const modules = [...new Set(questions.map(q => q.module))];
        return modules.sort((a, b) => {
            const moduleOrder = ['negocio', 'cliente', 'motivaciones', 'comportamiento', 'comunicacion', 'objeciones'];
            return moduleOrder.indexOf(a) - moduleOrder.indexOf(b);
        });
    };

    // Verificar si todas las preguntas de un módulo están respondidas
    const isModuleComplete = (module, responses) => {
        const moduleQuestions = getQuestionsByModule(module);
        return moduleQuestions.every(question => responses[question.question] !== undefined);
    };

    // Obtener progreso del módulo
    const getModuleProgress = (module, responses) => {
        const moduleQuestions = getQuestionsByModule(module);
        if (moduleQuestions.length === 0) return 0;

        const answeredQuestions = moduleQuestions.filter(question =>
            responses[question.question] !== undefined
        ).length;

        return (answeredQuestions / moduleQuestions.length) * 100;
    };

    return {
        // Estado
        questions,
        loading,
        error,

        // Acciones
        loadQuestions,

        // Utilidades
        getQuestionsByModule,
        getAvailableModules,
        isModuleComplete,
        getModuleProgress
    };
}; 